import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With over 15 years of experience in operations and customer experience (CX), how
                has your journey in banking shaped your leadership approach in driving service
                quality and digital transformation?
              </strong>
            </h5>

            <h5 className="text-white">
              Within my banking journey over the past 15 years, with collation of CX & Operations
              background, my leadership approach was based built though many different aspects such
              as; Customer-centric strategy through understanding pain points and designing
              solutions which will enhance the quality of service delivered to customers.Another
              important way was data driven decision making. a
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Customer experience in wholesale banking differs from retail banking in many
                ways. What are the unique challenges of CX in wholesale banking, and how is Mashreq
                Bank addressing them?
              </strong>
            </h5>
            <h5 className="text-white">
              Definitely banking in wholesale is very challenging due to the complexity of
              relationships of the companies, transaction sizes and the level of customization
              required, however, In Mashreq Bank we have been implementing relationship-based
              digital solution, automating and digitizing the onboarding and KYC journeys, via
              introducing the AI documents processing and ensuring a healthy automated workflow
              across all back-office services required.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You have played a key role in driving digital transformation initiatives. How do
                you see technology reshaping the future of CX in banking, and what are some key
                digital innovations at Mashreq Bank?
              </strong>
            </h5>
            <h5 className="text-white">
              Technology is fundamentally reshaping CX in banking, by making services personalized,
              seamless and efficient. In instances, we have been using AI and predictive analytics
              for personalization to anticipate customers needs and customize their financial
              solutions. In addition to Chatbots and virtual assistants powered by generative AI
              provide instant contextual support.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Improving service quality requires a balance between efficiency and
                personalization. What strategies have you implemented to enhance service quality
                while maintaining operational efficiency?
              </strong>
            </h5>
            <h5 className="text-white">
              Intelligent automation for faster services through RPA, AI driven chatbots and
              automated workflows that have been implemented to streamline banking processes and
              reduce turnaround time.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- As a Certified Scrum Master and LSSGB Practitioner, how have agile methodologies
                and lean principles influenced your approach to customer experience strategy and
                service enhancements?
              </strong>
            </h5>
            <h5 className="text-white">
              <br />
              1. Applying LSS methodologies to identify and eliminate wastes in customer journeys.
              <br />
              2. Conducting RCA to solve recurring service issues
              <br />
              3. Adopting a Test and Learn mindset by breaking large CX initiatives into smaller
              changes that can be tested, refined and scaled based on customer feedback.
              <br />
              4. Embedding the agile mindset by driving a continuous improvement culture across the
              whole banking processes.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Having worked with multinational banks in Egypt, the UAE, and the region, what
                key trends are shaping CX in regional banking, and how can banks stay ahead in the
                competitive landscape?
              </strong>
            </h5>
            <h5 className="text-white">
              Of course customers expect seamless mobile-first experience leading banks to invest
              heavily in app-based services, AI driven mobile apps via enhancing the UX/UI,
              moreover, hyper-personalization with AI & Data analytics.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- What key metrics do you use to assess the success of CX initiatives, and what
                emerging trends do you believe will redefine customer experience in wholesale
                banking over the next five years?
              </strong>
            </h5>
            <h5 className="text-white">
              The key metrics to assess CX success is a combination of Customer satisfaction,
              operational efficiency and financial impact, such as evaluating NPS, CSAT, and CES
              from the customer centric metrics, and from operational metrics, TAT, First Contact
              Resolution, and Digital Adoption Rate.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Finally, based on your extensive experience, what advice would you give to banking
                professionals looking to specialize in customer experience strategy and digital
                transformation?
              </strong>
            </h5>
            <h5 className="text-white">
              My simple advice is to listen to your customer, and continuously assess your digital
              as well manual and operational processes. Loyal customers will never stay with poor
              service, however, smart adoption for digital initiatives will attract targeted
              segmented customers.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
